import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import { API } from "../lib/utils";

export default function SearchBar() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const doSearch = async (v) => {
    setQ(v);
    if (v.length < 2) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/search`, { params: { q: v } });
      setResults(data.results || []);
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="open-search"
        aria-label="Open site search"
        className="text-[#c4bdb5] hover:text-[#e6c155] transition-colors"
      >
        <Search size={18} aria-hidden="true" />
      </button>

      {open && (
        <div
          data-testid="search-overlay"
          className="fixed inset-0 z-[70] bg-[#0a0908]/95 backdrop-blur-xl flex items-start justify-center pt-24 px-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-2xl bg-[#141210] border border-white/10"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center border-b border-white/10 px-5 py-4 gap-3">
              <Search size={18} className="text-[#d4af37]" />
              <input
                autoFocus
                value={q}
                onChange={(e) => doSearch(e.target.value)}
                placeholder="Search photographs, essays, prints…"
                data-testid="search-input"
                className="flex-1 bg-transparent text-[#f4f0ec] placeholder:text-[#78716c] focus:outline-none text-base"
              />
              <button onClick={() => setOpen(false)} className="text-[#a8a29e] hover:text-[#d4af37]">
                <X size={18} />
              </button>
            </div>
            <div className="max-h-[60vh] overflow-y-auto">
              {loading && (
                <p className="px-5 py-6 text-sm text-[#a8a29e] font-mono uppercase tracking-wider">Searching…</p>
              )}
              {!loading && q.length >= 2 && results.length === 0 && (
                <p className="px-5 py-8 text-sm text-[#a8a29e] italic">No matches for "{q}"</p>
              )}
              {results.map((r, i) => (
                <Link
                  key={i}
                  to={r.url}
                  onClick={() => setOpen(false)}
                  data-testid={`search-result-${i}`}
                  className="flex gap-4 items-center px-5 py-4 border-b border-white/5 hover:bg-white/[0.03] last:border-0"
                >
                  {r.image && (
                    <img src={r.image} alt="" loading="lazy" decoding="async" className="w-14 h-14 object-cover flex-shrink-0" />
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="text-[9px] font-mono uppercase tracking-[0.25em] text-[#d4af37] mb-1">
                      {r.type}
                    </p>
                    <p className="font-serif text-[#f4f0ec] truncate">{r.title}</p>
                    {r.subtitle && (
                      <p className="text-xs text-[#a8a29e] truncate mt-1">{r.subtitle}</p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
